export default __webpack_public_path__ + "static/sprej-ad2de07be18139ecf79c81d3753ee165.png";